import { useTranslation } from 'react-i18next';

export const useNameFormat = () => {
  const { t, i18n } = useTranslation();

  /**
   * 名前を言語に応じてフォーマットする
   * @param lastName - 姓
   * @param firstName - 名
   * @returns フォーマットされた名前文字列
   * @example
   * 日本語: "空野 太郎 様"
   * 英語: "Dear Taro Sorano"
   */
  const formatName = (lastName: string, firstName: string): string => {
    const honorific = t('common.honorific');

    if (i18n.language === 'en') {
      return `${honorific} ${firstName} ${lastName}`;
    }

    return `${lastName} ${firstName} ${honorific}`;
  };

  return {
    formatName,
  };
};
